module.exports = __webpack_public_path__ + "img/ic_next.f9290bd5.svg";